.container {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 40px;
    margin-bottom: 40px;
  }
  
  .title {
    font-size: 1.2em;
    margin-bottom: 16px;
  }
  
  .title-container {
    margin-bottom: 16px;
  }